import { RecordBucket } from "@scayla/api-client-fetch";
import type { RouteLocationNormalizedLoaded, Router } from "vue-router";

import { Routes } from "@/router";

/** Path of the list an open record closes back to: `returnTo` if given, else its module list or bin. */
export function resolveRecordReturnTo(
  router: Router,
  route: RouteLocationNormalizedLoaded,
  moduleId: string,
  returnTo?: string,
): string {
  if (returnTo) return returnTo;

  const { bucket, ...query } = route.query;
  const openedFromBin = bucket === RecordBucket.DELETED;

  return router.resolve({
    name: openedFromBin ? Routes.BIN : Routes.MODULE,
    params: { moduleId },
    query: openedFromBin ? query : route.query,
  }).fullPath;
}
